// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"c175f6bf","787":"186edd1e"}[chunkId] + ".chunk.js";
};